import React from "react";

import "./LoginBackground.scss";

const LoginBackground = () => {
  return <div className="login-bg" />;
};

export default LoginBackground;
